import React, { memo, useRef } from 'react';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import { Button, FilePreview } from 'ui-kit';
import { BUTTON_TYPES } from '_constants';
import * as Styled from './styles';

const MixedFileUploader = ({ onChange, value, name, onClean, acceptedTypes }) => {
  const fileInputRef = useRef(null);
  const inputId = uniqueId();

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <Styled.Wrapper>
      <FilePreview value={value} zoom />
      <Styled.InputWrapper>
        <Button text="Choose file" variant={BUTTON_TYPES.GREY} onClick={handleButtonClick} />
        <Styled.Input
          key={inputId}
          id={inputId}
          ref={fileInputRef}
          type="file"
          onChange={(e) => onChange(e, name)}
          accept={acceptedTypes}
        />
        <Button text="Clean" variant={BUTTON_TYPES.GREY} onClick={() => onClean(name)} />
      </Styled.InputWrapper>
    </Styled.Wrapper>
  );
};

MixedFileUploader.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClean: PropTypes.func.isRequired,
  acceptedTypes: PropTypes.string,
};

MixedFileUploader.defaultProps = {
  value: null,
  acceptedTypes: '',
};

export default memo(MixedFileUploader);
